import { Link, Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import { getIdToken, logout, getUserEmail } from "./lib/auth";

/**
 * Layout shell. Renders a slim header above the routed view.
 * The header shows the signed-in email + a Logout link when a session exists,
 * and just the brand otherwise.
 */
export default function App() {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string | null>(null);

  useEffect(() => {
    const token = getIdToken();
    setEmail(token ? getUserEmail() : null);
  }, []);

  return (
    <div className="layout">
      <header className="topbar">
        <Link to="/" className="brand">Cosmic Cow Capital</Link>
        <nav>
          {email ? (
            <>
              <Link to="/dashboard">Dashboard</Link>
              <Link to="/accounts">Accounts</Link>
              <Link to="/firms">Firms</Link>
              <Link to="/data">Data</Link>
              <Link to="/trade-log">Trade log</Link>
              <Link to="/payouts">Payouts</Link>
              <span className="email">{email}</span>
              <button
                className="link-button"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
              >
                Log out
              </button>
            </>
          ) : null}
        </nav>
      </header>
      <main className="content">
        <Outlet />
      </main>
      <footer className="footer">
        <span>Cosmic Cow Capital — v0.1</span>
      </footer>
    </div>
  );
}
